function formatPath(path: string): string {
  if (!path) return "";
  if (path[0] === "/") return path;

  return `/${path}`;
}

export const canonical = (path = "") => {
  const formattedPath = formatPath(path);

  return (
    <link rel="canonical" href={`https://weconceive.com${formattedPath}`} />
  );
};
